import { render, staticRenderFns } from "./NewcomerTraining.vue?vue&type=template&id=3aaaa756"
import script from "./NewcomerTraining.vue?vue&type=script&lang=js"
export * from "./NewcomerTraining.vue?vue&type=script&lang=js"
import style0 from "./NewcomerTraining.vue?vue&type=style&index=0&id=3aaaa756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports